import cx from 'classnames';

import CloseIcon from '@atlaskit/icon/core/close';
import { RovoIcon } from '@atlaskit/logo';
import { Button } from '@trello/nachos/button';
import { token } from '@trello/theme';

import * as styles from './RovoButton.module.less';

interface RovoButtonProps {
  isActive: boolean;
  onClick: () => void;
  triggerRef?: (node: HTMLElement | null) => void;
  isCardBackButton?: boolean;
}

export const RovoButton = ({
  isActive,
  onClick,
  triggerRef,
  isCardBackButton = false,
}: RovoButtonProps) => {
  return (
    <Button
      className={cx({
        [styles.rovoButton]: true,
        [styles.cardBackButton]: isCardBackButton,
      })}
      onClick={onClick}
      ref={triggerRef}
      aria-label={isActive ? 'Close Rovo' : 'Open Rovo'} // TODO: i18n
    >
      {!isActive ? (
        <RovoIcon label="Rovo" appearance="inverse" size="small" /> // TODO: i18n
      ) : (
        <CloseIcon
          label="Close" // TODO: i18n
          color={token('color.icon.inverse', '#ffffff')}
        />
      )}
    </Button>
  );
};
